export const JAVASCRIPT_RESOURCE = 'js';
export const IMAGE_RESOURCE      = 'pixel';


// WEBPACK FOOTER //
// ./src/Services/Reporting/ResourceTypes.js